import { CustomerInsightDtoSchema } from "@datamole/lssa-api-schema";

import { apiJS as baseApi } from "@/store/api";

const api = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getCustomerInsights: builder.query<CustomerInsightDtoSchema[], void>({
            query: () => ({
                url: `insights`,
                method: "GET",
            }),
        }),
    }),
});

export const { useGetCustomerInsightsQuery } = api;
